'use strict';
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.metadata` well-known symbol
// https://github.com/tc39/proposal-decorators
defineWellKnownSymbol('metadata');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/esnext.symbol.metadata.js
// module id = 749
// module chunks = 13